import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=c3acd1aa&"
import script from "./BlogCategory.vue?vue&type=script&lang=js&"
export * from "./BlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3acd1aa')) {
      api.createRecord('c3acd1aa', component.options)
    } else {
      api.reload('c3acd1aa', component.options)
    }
    module.hot.accept("./BlogCategory.vue?vue&type=template&id=c3acd1aa&", function () {
      api.rerender('c3acd1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/BlogCategory.vue"
export default component.exports